import { render, staticRenderFns } from "./searchKlav.vue?vue&type=template&id=2af367c6"
import script from "./searchKlav.vue?vue&type=script&lang=js"
export * from "./searchKlav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports